/*global TTLicenseStatusEnum, TTUserLicenseAssignment, TTEnterpriseLicenseAssignment */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import { Redirect }         from 'react-router-dom';
import validator            from 'validator';
import moment               from 'moment';
import cx                   from 'classnames';

import { Dialog } from 'moovila-common';

import CheckForDirtyUtility from '../../utilities/checkForDirty';

let idKey;
let guidKey;

const statuses = [
  { statusName: 'Approved', statusCode: TTLicenseStatusEnum.LS_APPROVED },
  { statusName: 'On Hold', statusCode: TTLicenseStatusEnum.LS_ON_HOLD },
  { statusName: 'Rejected', statusCode: TTLicenseStatusEnum.LS_REJECTED },
  { statusName: 'Requested', statusCode: TTLicenseStatusEnum.LS_REQUESTED },
];

const isMalformedDate = (dateString) => {
  return dateString.split('/').some((piece, i) => {
    if (i < 2) {
      return piece.length !== 2;
    }
    return piece.length !== 4;
  });
}

class AddEditLicenseAssignment extends Component {
  constructor(props) {
    super(props);

    const defaultState = this.props.context === 'users' ? new TTUserLicenseAssignment() : new TTEnterpriseLicenseAssignment();

    this.state = {
      ...defaultState,
      noStartDate: false,
      noEndDate: false,
      redirect: false,
    };

    this.handleChange =         this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleSubmit =         this.handleSubmit.bind(this);
  }

  componentWillMount() {
    if (!this.props.licenses.length) {
      this.setState({
        redirect: true,
      });
      return;
    }

    let freshState;

    const license = this.props.licenses.filter(l => l.licenseGUID === this.props.licenseGUID)[0];
    idKey = this.props.context === 'users' ? 'userLicenseID' : 'enterpriseLicenseID';
    guidKey = this.props.context === 'users' ? 'userGUID' : 'enterpriseGUID';
    const assignment = this.props.assignments.filter(a => {
      return a.licenseGUID === this.props.licenseGUID && String(a[idKey]) === this.props.licenseID;
    })[0];

    this.setState({
      [guidKey]: this.props.primaryGUID,
    });

    if (!assignment) {
      freshState = {
        licenseGUID: '',
        statusCode: 0,
        startDate: '',
        endDate: '',
        noStartDate: false,
        noEndDate: false,
      }

      this.setState({
        otherAssignments: this.props.assignments,
        isActive: true
      });

      this.checkForDirty = CheckForDirtyUtility(freshState);
      return;
    }

    freshState = {
      licenseGUID: license.licenseGUID,
      licenseStatusCode: assignment.licenseStatusCode,
      startDate: assignment.startDate ? moment(assignment.startDate).format('MM/DD/YYYY') : '',
      endDate: assignment.endDate ? moment(assignment.endDate).format('MM/DD/YYYY') : '',
      noStartDate: !assignment.startDate,
      noEndDate: !assignment.endDate,
    }

    this.setState({
      ...freshState,
      licenseID: this.props.licenseID,
      [idKey]: assignment[idKey],
      [guidKey]: this.props.primaryGUID,
      sku: assignment.sku,
      name: assignment.name,
      description: assignment.description,
      permissions: assignment.permissions,
      statusCode: assignment.statusCode,
      otherAssignments: this.props.assignments.filter(a => a.licenseGUID != this.props.licenseGUID),
      isActive: assignment.isActive
    });

    this.checkForDirty = CheckForDirtyUtility(freshState);
  }

  handleChange(e) {
    const { name, value } = e.target;
    if ((name === 'startDate' && this.state.noStartDate) || (name === 'endDate' && this.state.noEndDate)) {
      return;
    }
    this.setState({[name]: value});
  }

  handleCheckboxChange(name) {
    const thisDate = name === 'noStartDate' ? 'startDate' : 'endDate';
    if (this.state[name] === false) {
      this.setState({
        [thisDate]: '',
        [name]: true,
      });
      return;
    }
    this.setState({ [name]: false });
  }

  handleSubmit(e) {
    let message;
    if (!this.state.licenseGUID) {
      message = 'Please choose a license.';
    } else if (!this.state.statusCode) {
      message = 'Please choose a status.';
    } else if (!this.state.noStartDate && !this.state.startDate) {
      message = 'Please provide a start date';
    } else if (
      !this.state.noStartDate &&
      (
        !validator.isISO8601(moment(this.state.startDate).format()) ||
        isMalformedDate(this.state.startDate)
      )
    ) {
      message = 'Please provide a valid start date (MM/DD/YYYY)';
    } else if (!this.state.noEndDate && !this.state.endDate) {
      message = 'Please provide an end date';
    } else if (
      !this.state.noEndDate &&
      (
        !validator.isISO8601(moment(this.state.endDate).format()) ||
        isMalformedDate(this.state.endDate)
      )
    ) {
      message = 'Please provide a valid end date (MM/DD/YYYY)';
    } else if (!this.state.noStartDate && !this.state.noEndDate && validator.isBefore(moment(this.state.endDate).format(), moment(this.state.startDate).format())) {
      message = 'Please check that the end date occurs after the start date.';
    }

    if (message) {
      this.props.showMessageBox({
        title: 'Invalid Entry',
        message,
      });
      e.preventDefault();
      return;
    }

    const selectedLicense = this.props.licenses.filter(l => l.licenseGUID === this.state.licenseGUID)[0];

    const newAssignment = {
      [idKey]: this.state[idKey],
      [guidKey]: this.state[guidKey],
      licenseGUID: this.state.licenseGUID,
      startDate: this.state.noStartDate ? null : moment(this.state.startDate).format(),
      endDate: this.state.noEndDate ? null : moment(this.state.endDate).format(),
      statusCode: parseInt(this.state.statusCode),
      permissions: selectedLicense.permissions,
      name: selectedLicense.name,
      description: selectedLicense.description,
      sku: selectedLicense.sku,
      isActive: this.state.isActive,
    }

    const assignmentList = [...this.state.otherAssignments, newAssignment];
    const assignmentsBody = {
      [guidKey]: this.props.primaryGUID,
      licenses: assignmentList,
    }

    // make the damn call
    // don't tell me what to do, Sean
    if (this.props.context === 'users') {
      this.props.updateUserLicenseAssignment(assignmentsBody)
    } else {
      this.props.updateLicenseAssignment(assignmentsBody)
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/admin/enterprise-maintenance/enterprises' />;
    }
    const mode = this.props.mode;
    const licenseOptions = this.props.licenses.map((l, i) => <option key={i} value={l.licenseGUID}>{l.name}</option>);
    const statusOptions = statuses.map((s, i) => <option key={i} value={s.statusCode}>{s.statusName}</option>);
    const startDateClass = cx({
      'form-control dark-label': true,
      'disabled': this.state.noStartDate,
    });
    const endDateClass = cx({
      'form-control dark-label': true,
      'disabled': this.state.noEndDate,
    });

    return (
      <Dialog
        size='lg'
        title={ mode === 'EDIT' ? 'Edit License Assignment' : 'Add License Assignment' }
        backTo={this.props.backTo}
        yesText='Save'
        yesCallback={this.handleSubmit}
        noCallback={(e) => {
          if (this.checkForDirty.test(e, this.state)) {
            e.preventDefault();
            this.props.setQuestion({
              title: 'Unsaved Changes',
              message: 'You have unsaved changes. Are you sure you want to leave this page?',
              yesCallback: () => this.props.history.push(this.props.backTo),
            });
          }
        }}
      >
        <div>
          <section className='section'>
            <div className='row'>
              <div className='col-xs-7'>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='licenseGUID'>License</label>
                    <select name='licenseGUID' value={this.state.licenseGUID} onChange={this.handleChange} className='form-control'>
                      { this.state.licenseGUID ? null :
                        <option value=''>Select</option>
                      }
                      { licenseOptions }
                    </select>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-6 form-group'>
                    <label className='text-primary' htmlFor='startDate'>Start date</label>
                    <input value={this.state.startDate} onChange={this.handleChange} type='text' className={startDateClass} name='startDate' placeholder='00/00/0000' />
                    <div className='moo-form-element'>
                      <input
                        name='noStartDate'
                        checked={this.state.noStartDate}
                        id='noStartDate'
                        type='checkbox'
                      />
                      <label htmlFor='noStartDate' onClick={() => this.handleCheckboxChange('noStartDate')}></label>
                    </div>
                    <div className='form-info-wrapper light-label small pointer' style={{display: 'inline-block'}}>No start date</div>
                  </div>
                  <div className='col-xs-6 form-group'>
                    <label className='text-primary' htmlFor='endDate'>End date</label>
                    <input value={this.state.endDate} onChange={this.handleChange} type='text' className={endDateClass} name='endDate' placeholder='00/00/0000' />
                    <div className='moo-form-element'>
                      <input
                        name='noEndDate'
                        checked={this.state.noEndDate}
                        id='noEndDate'
                        type='checkbox'
                      />
                      <label htmlFor='noEndDate' onClick={() => this.handleCheckboxChange('noEndDate')}></label>
                    </div>
                    <div className='form-info-wrapper light-label small pointer' style={{display: 'inline-block'}}>No end date</div>
                  </div>
                </div>
              </div>
              <div className='col-xs-5'>
                <label className='text-primary' htmlFor='statusCode'>Status</label>
                <select name='statusCode' value={this.state.statusCode} onChange={this.handleChange} className='form-control'>
                  { this.state.statusCode ? null :
                    <option value=''>Select</option>
                  }
                  { statusOptions }
                </select>
              </div>
            </div>
          </section>
        </div>
      </Dialog>
    );
  }

}

export default AddEditLicenseAssignment;



// WEBPACK FOOTER //
// ./src/components/Admin/AddEditLicenseAssignment.js